const HTTP_URL_PATTERN = /^https?:\/\/\S+$/i;
const REFUSED_URL = '';

export function safeHttpUrl(url) {
  if (typeof url !== 'string') return REFUSED_URL;

  const trimmedUrl = url.trim();

  return HTTP_URL_PATTERN.test(trimmedUrl) ? trimmedUrl : REFUSED_URL;
}
